// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__o8lbP","loader":"MediumLoader_loader__41qLe","spinner-c7wet2":"MediumLoader_spinner-c7wet2__aHCC4"};